exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EmptyInbox-textLead-28z2p {\n\tcolor: var(--common-text-color);\n\tline-height: 1.1;\n}\n\n.EmptyInbox-widthImg-4KQqW {\n\twidth: 200px;\n}\n\n.EmptyInbox-textCenter-PgH-7 {\n\ttext-align: center;\n\tcolor: var(--common-text-Secondry-color);\n\tmax-width: 396px;\n\tmargin: 20px auto;\n\tfont-size: 18px;\n}\n\n.EmptyInbox-textMuted-Yf3qE {\n\tmargin: 20px 0;\n}", ""]);

// exports
exports.locals = {
	"textLead": "EmptyInbox-textLead-28z2p",
	"widthImg": "EmptyInbox-widthImg-4KQqW",
	"textCenter": "EmptyInbox-textCenter-PgH-7",
	"textMuted": "EmptyInbox-textMuted-Yf3qE"
};